const LOCALE_STORAGE_KEY = 'preferred_language';
const LOCALE_COOKIE_KEY = 'preferred_language';
const DEFAULT_LOCALE = 'en';
const SUPPORTED_LOCALES = ['en', 'es', 'de', 'it', 'fr', 'pt'];
const LEGACY_LOCALE_ALIASES = {
  sp: 'es',
  br: 'pt',
};

const LOCALE_OPTIONS = [
  { code: 'en' },
  { code: 'es' },
  { code: 'de' },
  { code: 'it' },
  { code: 'fr' },
  { code: 'pt' },
];

function normalizeLocale(locale) {
  if (!locale || typeof locale !== 'string') return null;
  const normalized = locale.toLowerCase().trim();
  const shortCode = normalized.split('-')[0];
  if (SUPPORTED_LOCALES.includes(shortCode)) return shortCode;
  return LEGACY_LOCALE_ALIASES[shortCode] || null;
}

function getBrowserLocale() {
  if (typeof navigator === 'undefined') return DEFAULT_LOCALE;
  const fromBrowser = normalizeLocale(navigator.language);
  return fromBrowser || DEFAULT_LOCALE;
}

function getPathLocale(pathname = typeof window !== 'undefined' ? window.location.pathname : '') {
  if (typeof pathname !== 'string') return null;
  const parts = pathname.trim().split('/').filter(Boolean);
  if (!parts.length) return null;
  return normalizeLocale(parts[0]);
}

function getLocaleBasePath(pathname = typeof window !== 'undefined' ? window.location.pathname : '') {
  const pathLocale = getPathLocale(pathname);
  return pathLocale && pathLocale !== DEFAULT_LOCALE ? `/${pathLocale}` : '';
}

function stripLocalePrefix(pathname = '') {
  if (typeof pathname !== 'string' || !pathname) return pathname || '/';
  const pathLocale = getPathLocale(pathname);
  if (!pathLocale) return pathname;

  const normalized = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const prefix = `/${pathLocale}`;
  if (normalized === prefix) return '/';
  if (normalized.startsWith(`${prefix}/`)) {
    return normalized.slice(prefix.length) || '/';
  }
  return normalized;
}

function getPreferredLocale() {
  if (typeof window === 'undefined') return DEFAULT_LOCALE;
  const fromPath = getPathLocale(window.location.pathname);
  if (fromPath) return fromPath;
  const stored = normalizeLocale(window.localStorage.getItem(LOCALE_STORAGE_KEY));
  return stored || getBrowserLocale();
}

function applyPreferredLocale() {
  const locale = getPreferredLocale();
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale;
  }
  if (typeof document !== 'undefined') {
    document.cookie = `${LOCALE_COOKIE_KEY}=${locale}; Path=/; Max-Age=31536000; SameSite=Lax`;
  }
  return locale;
}

function setPreferredLocale(locale) {
  const normalized = normalizeLocale(locale) || DEFAULT_LOCALE;

  if (typeof window !== 'undefined') {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, normalized);
    window.dispatchEvent(
      new CustomEvent('suarte:preferred-language-changed', {
        detail: { locale: normalized },
      }),
    );
  }

  if (typeof document !== 'undefined') {
    document.documentElement.lang = normalized;
    document.cookie = `${LOCALE_COOKIE_KEY}=${normalized}; Path=/; Max-Age=31536000; SameSite=Lax`;
  }

  return normalized;
}

export {
  DEFAULT_LOCALE,
  LOCALE_OPTIONS,
  SUPPORTED_LOCALES,
  applyPreferredLocale,
  getLocaleBasePath,
  getPathLocale,
  getPreferredLocale,
  setPreferredLocale,
  stripLocalePrefix,
};
